module.exports = __webpack_public_path__ + "media/categories/4102-ea5b7c4d.svg";